import syncTimerWithServerTime from '@/api/interceptors/serverTime.response.interceptor';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
});

axiosInstance.interceptors.request.use(requestOnFulfilled, requestOnRejected);
axiosInstance.interceptors.response.use(responseOnFulfilled, responseOnRejected);

function requestOnFulfilled(config: AxiosRequestConfig) {
  return config;
}

function requestOnRejected(error: any) {
  return Promise.reject(error);
}

function responseOnFulfilled(response: AxiosResponse) {
  syncTimerWithServerTime(response);

  return response.data;
}

function responseOnRejected(error: any) {
  if (error.response) {
    syncTimerWithServerTime(error.response);

    // Todo: create custom error model
    const customError: any = <any> new Error(error.response.data);

    customError.status = error.response.status;

    throw customError;
  }

  throw error;
}

// Todo: add plugin for axios
window.axios = axiosInstance;
